

exports.__esModule = true;
exports.$EndRoute = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _angular = require('angular');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _index = require('xo-models/src/checkout/index');

var _util = require('xo-return-to-merchant/dist/util');

var _returnParams = require('xo-page-components/src/returnParams');

var _profilemanagement = require('xo-models/src/profilemanagement');

var $EndRoute = exports.$EndRoute = _squid.$ComponentRoute.extend('EndRoute', {
    path: 'end',
    trackingData: {
        fptiState: 'back_to_merchant',
        trackStateExit: true
    },
    resolve: {
        action: function action() {

            function returnMethod(merchantPreferences) {
                if (_squid.$integration.getConfig('RETURN_METHOD_BASED_ON_MERCHANT_PREFS') && merchantPreferences) {
                    return merchantPreferences.returnMethod();
                } else {
                    return 'GET';
                }
            }

            function returnUrl(checkoutAppData, merchantPreferences, checkoutCart) {
                var return_uri = checkoutAppData.urls && checkoutAppData.urls.return_url;
                var billing = checkoutCart.billing || {};
                if (billing.intent === 'VAULT') {
                    var originalReturnUrl = checkoutAppData.urls && checkoutAppData.urls.original_urls && checkoutAppData.urls.original_urls.return_url;
                    return_uri = originalReturnUrl ? originalReturnUrl : return_uri;
                }

                if (checkoutAppData.is_wps_subscription_flow()) {
                    return _squid.$config.urls.wpsSubscriptionReturnUrl;
                }

                if (checkoutAppData.is_wps_installmentplan_flow()) {
                    return _squid.$config.urls.wpsInstallmentPlanReturnUrl;
                }

                if (checkoutAppData.isWpsAutobillingFlow()) {
                    return _squid.$config.urls.wpsAutobillingReturnUrl;
                }

                if (checkoutCart.isSubscriptionsV1()) {
                    return _squid.$config.urls.subscriptionsV1ReturnUrl;
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && _squid.$util.param('redirect_uri')) {
                    return _squid.$util.param('redirect_uri');
                }

                if (_squid.$integration.getConfig('RETURN_URL_FROM_MERCHANT_PREFS') && merchantPreferences) {
                    return return_uri || merchantPreferences.returnUrl();
                }

                // By default, use return_uri from checkout session
                return return_uri;
            }

            function returnParams(checkoutCart, checkoutSession, checkoutAppData, returnToMerchantMethod) {
                var billingData = checkoutCart.billing || {};
                var paramsForWPSBillingFlows = {
                    token: _squid.$meta.token,
                    mfid: _squid.$meta.mfid,
                    sdkMeta: _squid.$meta.sdkMeta,
                    mode: 'member',
                    'country.x': _squid.$locale.country,
                    'locale.x': _squid.$locale.lang + '_' + _squid.$locale.country
                };
                var paramsForVault = {
                    approval_token_id: billingData.vault_approval_token_id,
                    approval_session_id: billingData.vault_approval_session_id
                };

                if (billingData.intent === 'VAULT') {
                    return paramsForVault;
                }

                if (checkoutAppData.is_wps_subscription_flow() || checkoutAppData.is_wps_installmentplan_flow() || checkoutAppData.isWpsAutobillingFlow()) {
                    return paramsForWPSBillingFlows;
                }

                var params = {};

                if (checkoutCart.isSubscriptionsV1()) {
                    params = _extends({}, paramsForWPSBillingFlows);
                }

                // Don't post PayerID for RT without purchase
                if (_squid.$integration.getConfig('ALLOW_PAYER_ID_RETURN_PARAM') && !checkoutCart.isBillingNoPurchase()) {
                    params.PayerID = checkoutSession.payer.id;
                }

                if (billingData.ba_token && !checkoutAppData.legacy_billing_integration) {
                    params.ba_token = billingData.ba_token;
                }

                if (_squid.$integration.isFlow('WPS')) {
                    var isCartUpload = checkoutAppData.flags.is_cart_upload_flow || checkoutAppData.flags.is_shopping_cart_flow;

                    params = (0, _returnParams.$returnParams)(checkoutCart, checkoutSession, returnToMerchantMethod, 'WPS', isCartUpload);
                }

                // When "redirect_uri" is passed as a query param
                if (_squid.$integration.getConfig('REDIRECT_QUERY_PARAM') && _squid.$util.param('redirect_uri')) {
                    if (checkoutAppData.urls.return_url) {
                        params.return_uri = _squid.$util.buildURL(checkoutAppData.urls.return_url, params);
                    }

                    // Add these params after building `return_uri` to ensure they are not added into the final url
                    params.intent = checkoutCart.payment_action;
                    params.opType = 'payment';
                    params.paymentId = checkoutAppData.payment_id;
                    params.token = _angular.$rootScope.token;
                }

                return params;
            }

            function getMerchantPreferences(dataModel) {
                if (_squid.$integration.getConfig('POPULATE_MERCHANT_PREFERENCES')) {
                    return (0, _squid.$populate)(dataModel, {
                        merchantPreferences: _profilemanagement.$MerchantPreferenceModel.instance(dataModel.payee.merchant.id)
                    });
                } else {
                    return _angular.$q.when();
                }
            }

            var models = {};

            return (0, _squid.$populate)(models, {
                checkoutAppData: _index.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                checkoutCart: _index.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                payee: _index.$CheckoutPayeeModel.instance(_angular.$rootScope.token)
            }).then(function () {
                return getMerchantPreferences(models);
            }).then(function () {
                var url = returnUrl(models.checkoutAppData, models.merchantPreferences, models.checkoutCart);
                var returnToMerchantMethod = returnMethod(models.merchantPreferences);
                var params = returnParams(models.checkoutCart, models.checkoutSession, models.checkoutAppData, returnToMerchantMethod);
                _logger.$logger.info('checkout_fpti', {
                    'from': 'BACK_TO_MERCHANT',
                    'to': 'prepare_bk_to_merchant',
                    'redirect_url': url,
                    'client_epoch_ts': Date.now()
                });

                if (models.checkoutAppData.is_wps_subscription_flow() || models.checkoutCart.isSubscriptionsV1() || models.checkoutAppData.isWpsAutobillingFlow()) {
                    return _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }
                if (models.checkoutAppData.is_wps_installmentplan_flow()) {
                    _squid.$util.redirect(_squid.$util.paypalURL(url, params));
                }

                if (window.xprops && window.xprops.getConnectURL) {
                    _logger.$logger.info('xprops_connect_redirect');

                    return window.xprops.getConnectURL().then(function (connectURL) {
                        return _squid.$util.redirect(connectURL);
                    });
                }

                // if V4 in-context integration, we'll call the onAuthorize handler.
                if (window.xprops && window.xprops.onAuthorize) {
                    _logger.$logger.info('xprops_onauthorize');
                    _logger.$logger.flush();
                    _angular.$rootScope.$emit('loading');

                    var xparams = {
                        paymentToken: _angular.$rootScope.token,
                        orderID: _angular.$rootScope.token,
                        billingToken: params['ba_token'],
                        payerID: params['PayerID'],
                        paymentID: params['paymentId'] || models.checkoutAppData.payment_id,
                        intent: models.checkoutCart.payment_action
                    };

                    if (url) {
                        xparams.returnUrl = _squid.$util.buildURL(url, params);
                    }
                    return window.xprops.onAuthorize(xparams);
                }

                if (returnToMerchantMethod === 'POST') {
                    _logger.$logger.info('post_redirect');
                    _logger.$logger.flush();
                    _util.$ReturnToMerchant.postTo(url, params);
                } else {
                    _logger.$logger.info('standard_redirect');
                    _logger.$logger.flush();
                    // if PDT is disabled don't send params in the url
                    if (models.merchantPreferences && !models.merchantPreferences.pdtEnabled()) {
                        return _util.$ReturnToMerchant.goTo(url);
                    }
                    _util.$ReturnToMerchant.goTo(_squid.$util.buildURL(url, params));
                }

                return _squid.$unresolved;
            });
        }
    }
});

angular.value("$EndRoute", $EndRoute);
_angular.$q;

_angular.$rootScope;

_logger.$logger;

_squid.$meta;

_squid.$util;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$unresolved;

_squid.$integration;

_squid.$ComponentRoute;

_index.$CheckoutCartModel;

_index.$CheckoutPayeeModel;

_index.$CheckoutSessionModel;

_index.$CheckoutAppDataModel;

_util.$ReturnToMerchant;

_returnParams.$returnParams;

_profilemanagement.$MerchantPreferenceModel;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-end/route.js
// module id = ./pages/xo-end/route.js
// module chunks = main-code-split